// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gen-modal-container {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;

  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

.gen-modal-content {
  min-height: 256px;
  max-height: 452px;
  background-color: white;
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.gen-modal-content .gen-modal-btns {
  display: flex;
  justify-content: space-between;
  margin-top: 46px;
  gap: 8px;
}

#gen-modal-btn {
  margin: 0px;
  height: 40px;
  border-radius: 8px;
  box-shadow: none;
  font-size: 16px;
  text-transform: none;
}

#gen-modal-btn:hover {
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/Modal/GeneralModal/GeneralModal.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;;EAEb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".gen-modal-container {\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.gen-modal-content {\n  min-height: 256px;\n  max-height: 452px;\n  background-color: white;\n  border-radius: 8px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.gen-modal-content .gen-modal-btns {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 46px;\n  gap: 8px;\n}\n\n#gen-modal-btn {\n  margin: 0px;\n  height: 40px;\n  border-radius: 8px;\n  box-shadow: none;\n  font-size: 16px;\n  text-transform: none;\n}\n\n#gen-modal-btn:hover {\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
